import {create} from "zustand";

const getDefaultSnackbarState = () => ({
    open: false,
    text: '',
    autoHide: 3000,
    severity: 'success',
    basket: false
});

export const useNotificationStore = create((set) => ({
    notificationState: getDefaultSnackbarState(),

    show: (data = {}) => set(() => ({
        notificationState: {
            ...getDefaultSnackbarState(),
            ...data,
            open: true
        }
    })),

    showSuccess: (text) => set(() => ({
        notificationState: {
            ...getDefaultSnackbarState(),
            text,
            open: true
        }
    })),

    showError: (text) => set(() => ({
        notificationState: {
            ...getDefaultSnackbarState(),
            text,
            severity: 'error',
            open: true
        }
    })),

    open: () => set((state) => ({
        notificationState: {
            ...state.notificationState,
            open: true
        }
    })),

    close: () => set((state) => ({
        notificationState: {
            ...state.notificationState,
            open: false
        }
    })),

    reset: () => set({
        notificationState: getDefaultSnackbarState()
    })
}));
